function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#5F37FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.22217 8.87489L9.99995 5.5L12.7777 8.87489",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 8.875L13.8889 13.3749C13.8369 13.6973 13.6973 13.9864 13.4943 14.192C13.2913 14.3975 13.0377 14.5065 12.7778 14.4998H7.22222C6.96228 14.5065 6.70873 14.3975 6.50571 14.192C6.30269 13.9864 6.16306 13.6973 6.11111 13.3749L5 8.875H15Z",
  fill: "white",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 13.3375C10.8284 13.3375 11.5 12.6575 11.5 11.8188C11.5 10.98 10.8284 10.3 10 10.3C9.17157 10.3 8.5 10.98 8.5 11.8188C8.5 12.6575 9.17157 13.3375 10 13.3375Z",
  stroke: "#5F37FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgStoreIcon = function SvgStoreIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStoreIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/storeIcon.40265dd7.svg";
export { ForwardRef as ReactComponent };